// ============================================================================
// forumData.js — a fórum tiszta, tesztelhető adatlogikája (2026-10-09, a chat fórummá alakítása).
// A lekérdezéseket a firebaseClient.js futtatja; itt csak a döntések vannak.
// ============================================================================

export const ELOZMENY_ID = "elozmeny";

// Munkafolyamat-státuszok és címkecsoportok (2026-10-16, v77): a sorrend a munkafolyamat sorrendje. A szerver (forumJelolo.js) ugyanezt a listát várja.
export const WORKFLOW_ALLAPOTOK = ["new", "ocr", "translating", "review", "done"];
// A "status" (állapot / jelzés) csoport a hozzászólások jelölésére is való (hibabejelentés, csatolt dokumentum állapota).
// Forrásmegjelölés mezői (2026-10-18); a szerver (forumJelolo.js ellenorizForras) ugyanezeket várja.
export const FORRAS_MEZOK = ["work", "year", "pages", "holder", "terms", "link"];

/** A téma forrásmegjelölése a felületnek: csak a nem üres szöveges mezők. */
export function forrasBol(x) {
  const ki = {};
  if (x && typeof x === "object" && !Array.isArray(x)) {
    for (const k of FORRAS_MEZOK) if (typeof x[k] === "string" && x[k].trim() !== "") ki[k] = x[k].trim();
  }
  return ki;
}

/** Csak https hivatkozás nyitható meg (a "javascript:" / "http:" cím soha nem lesz kattintható). */
export function biztonsagosHivatkozas(s) {
  return typeof s === "string" && /^https:\/\/[^\s<>"']+$/i.test(s) ? s : null;
}

/**
 * A státusz-előzmény a felületnek (2026-10-18): a szerver legfeljebb 30 bejegyzést tárol a téma dokumentumában; itt csak a szabályos
 * bejegyzések maradnak, a legújabb elöl. A státuszkulcs ismeretlen értéke üres ("nincs státusz") lesz.
 */
export function wfNaploBol(x) {
  const ok = (a) => (WORKFLOW_ALLAPOTOK.includes(a) ? a : "");
  const ki = [];
  for (const b of Array.isArray(x) ? x : []) {
    if (!b || typeof b !== "object" || typeof b.at !== "number") continue;
    ki.push({
      from: ok(b.from), to: ok(b.to),
      by: typeof b.by === "string" ? b.by : "", byName: typeof b.byName === "string" ? b.byName : "",
      at: b.at, note: typeof b.note === "string" ? b.note : "",
    });
  }
  return ki.reverse();
}

export const CIMKE_CSOPORTOK = ["person", "docType", "era", "status"];

/** Egy téma dokumentuma a felületnek. */
export function temaDokumentumbol(id, d) {
  const x = d || {};
  const ms = (ts) => (ts && typeof ts.toMillis === "function" ? ts.toMillis() : typeof ts === "number" ? ts : null);
  return {
    topicId: id,
    kind: x.kind === "history" || x.kind === "moved" ? x.kind : "discussion",
    // Téma -> szoba átalakítás (2026-10-15): az átirányító téma az új szobára mutat.
    movedToRoomId: x.kind === "moved" && typeof x.movedToRoomId === "string" ? x.movedToRoomId : null,
    // Téma -> másik szoba áthelyezés (2026-10-19): az átirányító téma a cél szoba azonos azonosítójú témájára mutat.
    movedToTopicId: x.kind === "moved" && typeof x.movedToTopicId === "string" ? x.movedToTopicId : null,
    // Zárolt téma (2026-10-19): senki nem írhat bele, nem módosítható; csak az admin oldhatja fel.
    locked: x.locked === true,
    title: typeof x.title === "string" ? x.title : "",
    titleTranslations: x.titleTranslations && typeof x.titleTranslations === "object" ? x.titleTranslations : {},
    // Az admin által FIXEN megadott (javított) nyelvi címek - elsőbbséget élveznek a gépi fordítással szemben.
    titleManual: x.titleManual && typeof x.titleManual === "object" ? x.titleManual : {},
    titleLang: typeof x.titleLang === "string" ? x.titleLang : (typeof x.sourceLang === "string" ? x.sourceLang : ""),
    status: x.status === "closed" ? "closed" : "open",
    // Munkafolyamat-státusz (nem azonos a fenti open/closed-dal) és a szoba címkekatalógusának azonosítói.
    workflow: WORKFLOW_ALLAPOTOK.includes(x.workflow) ? x.workflow : "",
    tags: Array.isArray(x.tags) ? x.tags.filter((c) => typeof c === "string") : [],
    // Státusz megjegyzése és előzménye (2026-10-18): az utolsó megjegyzés, és a változások naplója (legújabb elöl).
    workflowNote: typeof x.workflowNote === "string" ? x.workflowNote : "",
    // Felelős (név) és határidő (ÉÉÉÉ-HH-NN), 2026-10-18.
    workflowAssignee: typeof x.workflowAssignee === "string" ? x.workflowAssignee : "",
    workflowDue: typeof x.workflowDue === "string" && /^\d{4}-\d{2}-\d{2}$/.test(x.workflowDue) ? x.workflowDue : "",
    workflowLog: wfNaploBol(x.workflowLog),
    // Forrásmegjelölés (2026-10-18): mű, év, oldal, őrzési hely, felhasználási feltétel, hivatkozás az eredetire.
    source: forrasBol(x.source),
    pinned: x.pinned === true,
    postCount: Number.isInteger(x.postCount) ? x.postCount : 0,
    lastPostAt: ms(x.lastPostAt),
    lastPostByName: typeof x.lastPostByName === "string" ? x.lastPostByName : "",
    // Az utolsó hozzászóló névváltozatai (2026-10-16): a lista az OLVASÓ írásrendszerében mutatja a nevet, mint az üzenetek.
    lastPostByNameLatn: typeof x.lastPostByNameLatn === "string" ? x.lastPostByNameLatn : "",
    lastPostByNameJa: typeof x.lastPostByNameJa === "string" ? x.lastPostByNameJa : "",
    lastPostByNameZh: typeof x.lastPostByNameZh === "string" ? x.lastPostByNameZh : "",
    lastPostByNameKo: typeof x.lastPostByNameKo === "string" ? x.lastPostByNameKo : "",
    lastPostByNameCyr: typeof x.lastPostByNameCyr === "string" ? x.lastPostByNameCyr : "",
    lastPostByNameEl: typeof x.lastPostByNameEl === "string" ? x.lastPostByNameEl : "",
    // A törölt tag hozzászólásai "Törölt tag" néven maradnak (lib/userPurge.js: a semleges "deleted" jelölő).
    lastPostByDeleted: x.lastPostBy === "deleted",
    createdBy: typeof x.createdBy === "string" ? x.createdBy : "",
    watchers: Array.isArray(x.watchers) ? x.watchers : [],
    historyMessageCount: Number.isInteger(x.historyMessageCount) ? x.historyMessageCount : 0,
    historyFrom: ms(x.historyFrom),
    historyTo: ms(x.historyTo),
  };
}

/**
 * Az utolsó hozzászóló neve a néző nyelvén: az üzenetekkel azonos szabály (nameVariants.js pickSenderName) - a megadott
 * írásmód-változat a néző nyelvének írásrendszere szerint, hiányában az eredeti név. Törölt tagnál a megadott "törölt" felirat.
 * @param {(src: object, lang: string) => string} pickSenderName
 */
export function utolsoHozzaszolo(tema, viewerLang, torolt, pickSenderName) {
  if (!tema) return "";
  if (tema.lastPostByDeleted) return torolt;
  return pickSenderName({
    senderName: tema.lastPostByName,
    senderNameLatn: tema.lastPostByNameLatn,
    senderNameJa: tema.lastPostByNameJa,
    senderNameZh: tema.lastPostByNameZh,
    senderNameKo: tema.lastPostByNameKo,
    senderNameCyr: tema.lastPostByNameCyr,
    senderNameEl: tema.lastPostByNameEl,
  }, viewerLang) || "";
}

/**
 * A téma címe a néző nyelvén. Sorrend: az admin által megadott (javított) cím -> a gépi fordítás -> az eredeti.
 * Ahol van kézi cím, azt használja a rendszer (a gép azt a nyelvet nem is fordítja).
 */
export function temaCim(tema, viewerLang) {
  if (!tema) return "";
  const kezi = tema.titleManual && tema.titleManual[viewerLang];
  if (typeof kezi === "string" && kezi.trim() !== "") return cimJelolesNelkul(kezi);
  return cimJelolesNelkul((tema.titleTranslations && tema.titleTranslations[viewerLang]) || tema.title || "");
}

/** v216: a címben a Markdown-jelölés (***Név***, `kód`) nem jelenik meg - a régi, már mentett címeknél sem (a szerver az újakat eleve tisztítja). */
function cimJelolesNelkul(szoveg) {
  return typeof szoveg === "string" ? szoveg.replace(/[*`]+/g, "").replace(/\s+/g, " ").trim() : "";
}

/**
 * A "címek nyelvenként" szerkesztő sorai: MINDEN rendszernyelv (a nyelvek.json-ból, új nyelvvel bővül), a
 * kézi címmel előtöltve; a gépi fordítás (vagy a forrásnyelvnél az eredeti cím) csak halvány súgó.
 */
export function cimSzerkesztoSorok(tema, nyelvek) {
  return Object.entries(nyelvek || {}).map(([kod, nev]) => ({
    kod,
    nev,
    ertek: (tema.titleManual && tema.titleManual[kod]) || "",
    sugo: kod === tema.titleLang ? tema.title : (tema.titleTranslations && tema.titleTranslations[kod]) || "",
    forras: kod === tema.titleLang,
  }));
}

/** A szervernek küldendő lista: csak a kitöltött (nem üres) mezők; az üres = a gép fordít. */
export function cimekKuldesre(ertekek) {
  return Object.fromEntries(Object.entries(ertekek || {}).map(([k, v]) => [k, String(v || "").trim()]).filter(([, v]) => v !== ""));
}

/** Olvasatlan hozzászólások száma a témában a szerveren tárolt olvasottság szerint. */
export function olvasatlanDb(tema, roomId, olvasott) {
  if (!tema || tema.kind === "history" || tema.kind === "moved") return 0;
  const latott = olvasott && Number.isInteger(olvasott[`${roomId}/${tema.topicId}`]) ? olvasott[`${roomId}/${tema.topicId}`] : 0;
  return Math.max(0, tema.postCount - latott);
}

/**
 * A témalista sorrendje: az előzmény legfelül (a fórum nyitó hozzászólása), utána a kitűzöttek,
 * majd a legfrissebb hozzászólás szerint.
 */
export function temaSorrend(temak) {
  const sor = (t) => (t.kind === "history" ? 0 : t.pinned ? 1 : 2);
  return [...(temak || [])].sort((a, b) => sor(a) - sor(b) || (b.lastPostAt || 0) - (a.lastPostAt || 0));
}

/** Írható-e a téma a nézőnek? Előzménybe soha; lezártba csak admin; csak olvasható szobában csak admin. */
export function temaIrhato(tema, { isAdmin = false, szobaIrhato = true } = {}) {
  if (!tema || tema.kind === "history" || tema.kind === "moved") return false;
  if (!szobaIrhato) return false;
  // Zárolt téma (2026-10-19): senki nem írhat bele, az admin sem.
  if (tema.locked === true) return false;
  if (tema.status === "closed" && !isAdmin) return false;
  return true;
}

/** A témán belüli lekérdezés leírása (a firebaseClient.js ez alapján épít lekérdezést). */
export function temaLekeres(tema) {
  if (!tema) return null;
  if (tema.kind === "history") return { tipus: "elozmeny", eddig: tema.historyTo };
  return { tipus: "tema", topicId: tema.topicId };
}

/** A legnagyobb látott sorszám a betöltött hozzászólások közül (olvasottnak jelöléshez). */
export function legnagyobbSorszam(uzenetek) {
  let m = 0;
  for (const u of uzenetek || []) if (Number.isInteger(u.postNumber) && u.postNumber > m) m = u.postNumber;
  return m;
}

/**
 * Az ellenőrzési pecsétek a felületnek (2026-10-18): csak a szabályos bejegyzések, régebbi elöl, legfeljebb 8.
 * @returns {Array<{lang: string, by: string, byName: string, at: number, src: string, text: string, note: string}>}
 */
export function pecsetekBol(x) {
  const ki = [];
  for (const r of Array.isArray(x) ? x : []) {
    if (!r || typeof r !== "object" || typeof r.lang !== "string" || typeof r.at !== "number") continue;
    ki.push({
      lang: r.lang, by: typeof r.by === "string" ? r.by : "", byName: typeof r.byName === "string" ? r.byName : "", at: r.at,
      src: typeof r.src === "string" ? r.src : "", text: typeof r.text === "string" ? r.text : "", note: typeof r.note === "string" ? r.note : "",
    });
  }
  return ki.slice(-8);
}

/**
 * Egy hozzászólás kapcsolatai az "alap" és az "utód" mezőkből (2026-10-18): amire épül (és módosult-e azóta), amit leváltott, és ami őt váltotta / rá épül.
 * Csak a betöltött üzenetek között keres (az ismeretlen cél nem jelenik meg). A "módosult" a cél szövegváltozata (textRevision) a kapcsoláskor jegyzettől eltér.
 */
export function kapcsolatInfo(msg, osszes) {
  const lista = Array.isArray(osszes) ? osszes : [];
  const keres = (id) => (id ? lista.find((x) => x && x.messageId === id) || null : null);
  const info = (x) => ({ id: x.messageId, num: Number.isInteger(x.postNumber) ? x.postNumber : null, name: typeof x.senderName === "string" ? x.senderName : "" });
  const rev = (x) => (Number.isInteger(x.textRevision) ? x.textRevision : 1);
  const alap = keres(msg && msg.basedOn);
  const utod = keres(msg && msg.supersedes);
  const id = msg && msg.messageId;
  return {
    basedOn: alap ? { ...info(alap), stale: Number.isInteger(msg.basedOnRev) && rev(alap) !== msg.basedOnRev } : null,
    supersedes: utod ? info(utod) : null,
    supersededBy: id ? lista.filter((x) => x && x.supersedes === id && x.deleted !== true).map(info) : [],
    dependents: id ? lista.filter((x) => x && x.basedOn === id && x.deleted !== true).map((x) => ({ ...info(x), stale: Number.isInteger(x.basedOnRev) && rev(msg) !== x.basedOnRev })) : [],
  };
}

/** A kapcsolat-sor gyorsítótár-aláírásához: a kapcsolódó hozzászólások változása (szám, módosulás) is újrarajzolást kérjen. */
export function kapcsolatKulcs(msg, osszes) {
  try {
    return JSON.stringify(kapcsolatInfo(msg, osszes));
  } catch (e) {
    return "";
  }
}

/** A pecsétnapló a felületnek (felváltott / visszavont pecsétek, 2026-10-18): legfeljebb 10, régebbi elöl. */
export function pecsetNaploBol(x) {
  const ki = [];
  for (const r of Array.isArray(x) ? x : []) {
    if (!r || typeof r !== "object" || typeof r.lang !== "string" || typeof r.at !== "number") continue;
    ki.push({
      lang: r.lang, by: typeof r.by === "string" ? r.by : "", byName: typeof r.byName === "string" ? r.byName : "", at: r.at,
      text: typeof r.text === "string" ? r.text : "", note: typeof r.note === "string" ? r.note : "",
      ended: ["replaced", "withdrawn", "dropped"].includes(r.ended) ? r.ended : "dropped", endedAt: typeof r.endedAt === "number" ? r.endedAt : 0,
    });
  }
  return ki.slice(-10);
}

/**
 * A pecsét még érvényes-e a hozzászólás MOSTANI szövegére? Érvényes, ha az eredeti szöveg ÉS az ellenőrzött nyelvi szöveg (a forrásnyelven maga
 * az eredeti, másutt a fordítás) változatlanul azonos azzal, amit a pecsét őriz; különben "elavult" (szerkesztés / újrafordítás után).
 * @returns {"ervenyes"|"elavult"}
 */
export function pecsetAllapot(msg, pecset) {
  const m = msg || {};
  const forras = typeof m.sourceLang === "string" && m.sourceLang ? m.sourceLang : null;
  const jelenlegi = forras === null || pecset.lang === forras ? m.text : (m.translations && m.translations[pecset.lang]);
  return m.text === pecset.src && jelenlegi === pecset.text ? "ervenyes" : "elavult";
}

/** Lejárt-e a határidő? A mai napot a helyi időzóna szerint nézzük; a kész státuszú téma sosem "lejárt". */
export function hataridoLejart(due, workflow, most = new Date()) {
  if (typeof due !== "string" || due === "" || workflow === "done") return false;
  const ma = `${most.getFullYear()}-${String(most.getMonth() + 1).padStart(2, "0")}-${String(most.getDate()).padStart(2, "0")}`;
  return due < ma;
}

/** A szoba címkekatalógusa a felületnek: csak a jól formált elemek, a csoportok szerint rendezetlenül (a nézet csoportosít). */
export function katalogusBol(lista) {
  if (!Array.isArray(lista)) return [];
  const ki = [];
  for (const c of lista) {
    if (!c || typeof c.id !== "string" || typeof c.name !== "string" || !CIMKE_CSOPORTOK.includes(c.group)) continue;
    const names = c.names && typeof c.names === "object" && !Array.isArray(c.names) ? c.names : {};
    ki.push({ id: c.id, group: c.group, name: c.name, names });
  }
  return ki;
}

/** A címke neve a néző (tartalom-)nyelvén; ha ott nincs megadva, az eredeti név. */
export function cimkeNev(cimke, lang) {
  if (!cimke) return "";
  const fordit = cimke.names && cimke.names[lang];
  return typeof fordit === "string" && fordit.trim() !== "" ? fordit : cimke.name;
}

/** A téma címkéi a katalógus sorrendjében; a katalógusból közben törölt azonosítók elhagyódnak. */
export function temaCimkei(tema, katalogus) {
  const ids = new Set((tema && tema.tags) || []);
  return (katalogus || []).filter((c) => ids.has(c.id));
}

/**
 * Szűrés státusz és címkék szerint. A szűrő: { workflow: "" | státusz, tags: [azonosítók] }.
 * Egy csoporton BELÜL a kijelölt címkék közül elég egy (VAGY), a csoportok KÖZÖTT mindegyiknek teljesülnie kell (ÉS):
 * "Usui VAGY Tomita" + "kézirat" = a kéziratok, amik Usuihoz vagy Tomitához tartoznak. Aktív szűrő mellett az
 * előzmény- és átirányító téma elrejtődik (nincs státusza, címkéje).
 */
export function szuresTemakre(temak, szuro, katalogus) {
  const f = szuro || {};
  const kivalasztott = Array.isArray(f.tags) ? f.tags : [];
  if (!f.workflow && kivalasztott.length === 0) return temak || [];
  const csoportonkent = new Map();
  for (const c of katalogus || []) {
    if (!kivalasztott.includes(c.id)) continue;
    if (!csoportonkent.has(c.group)) csoportonkent.set(c.group, new Set());
    csoportonkent.get(c.group).add(c.id);
  }
  return (temak || []).filter((t) => {
    if (t.kind === "history" || t.kind === "moved") return false;
    if (f.workflow && t.workflow !== f.workflow) return false;
    for (const ids of csoportonkent.values()) if (!(t.tags || []).some((id) => ids.has(id))) return false;
    return true;
  });
}

/** A szűrő be- / kikapcsolt címkével (a kijelölt lista másolata). */
export function szuroCimkeValtas(szuro, id) {
  const f = szuro || { workflow: "", tags: [] };
  const tags = f.tags.includes(id) ? f.tags.filter((x) => x !== id) : [...f.tags, id];
  return { ...f, tags };
}

/** Státuszonkénti darabszám a jelenlegi (címkékkel szűrt) listában - a szűrő legördülőjének számai. */
export function allapotSzamok(temak) {
  const szamok = Object.fromEntries(WORKFLOW_ALLAPOTOK.map((a) => [a, 0]));
  for (const t of temak || []) if (t.workflow && t.workflow in szamok) szamok[t.workflow] += 1;
  return szamok;
}

/** Egy elem (téma / hozzászólás) megfelel-e a kijelölt címkéknek? Csoporton belül VAGY, csoportok között ÉS. */
function cimkeEgyezes(elem, kivalasztott, katalogus) {
  const csoportonkent = new Map();
  for (const c of katalogus || []) {
    if (!kivalasztott.includes(c.id)) continue;
    if (!csoportonkent.has(c.group)) csoportonkent.set(c.group, new Set());
    csoportonkent.get(c.group).add(c.id);
  }
  for (const ids of csoportonkent.values()) if (!((elem && elem.tags) || []).some((id) => ids.has(id))) return false;
  return true;
}

/**
 * A témán belüli hozzászólások szűrése címke szerint (2026-10-16). Szűrő nélkül (vagy csak ismeretlen címkékkel) mindent mutat;
 * a szabály ugyanaz, mint a témalistán (cimkeEgyezes).
 */
export function uzenetSzures(uzenetek, kivalasztott, katalogus) {
  const ki = Array.isArray(kivalasztott) ? kivalasztott : [];
  if (ki.length === 0) return uzenetek || [];
  return (uzenetek || []).filter((u) => cimkeEgyezes(u, ki, katalogus));
}

/** A betöltött hozzászólásokon ténylegesen használt címkék a katalógus sorrendjében (a szűrősor csak ezeket kínálja). */
export function hasznaltCimkek(uzenetek, katalogus) {
  const hasznalt = new Set();
  for (const u of uzenetek || []) if (u && !u.deleted && Array.isArray(u.tags)) for (const id of u.tags) hasznalt.add(id);
  return (katalogus || []).filter((c) => hasznalt.has(c.id));
}
